export default {
    DOLLAR_YEAR: '<DollarYear>',
};
